/**
 * @owner @Appboy/core-objects
 */
import { customObjectsTypeNameSchemaFields } from "../customObjectsTypeNameSchemaFields/constants";
import type { AllRouteEndpoints } from "../routeTypes";

export const customObjectsTypeNameSchemaFieldsFieldName =
  "/custom_objects/:type_name/schema/fields/:field_name" as const;

/** Invalidate the fields list GET cache after single-field update/delete mutations. */
export const customObjectsTypeNameSchemaFieldsFieldNameCacheKeys: AllRouteEndpoints[] = [
  customObjectsTypeNameSchemaFields,
];
